const currentCustomer = (state = {}, action) => {
    switch(action.type){
        case "SET_CUSTOMER":
            return {
                ...state,
                user: action.payload
            }
        default:
            return state
    }
}

export default currentCustomer;